
import {Component, Prop, Vue} from 'vue-property-decorator';
import SAccProjectJira from "@/components/projects/SAccProjectJira.vue";
import {ProjectDocument} from "@/interfaces/project.interfaces";
import {ServiceDocument} from "@/interfaces/service.interfaces";
import {fetchServices} from "@/axios/axios.service";
import {AccountDocument} from "@/interfaces/account.interfaces";

@Component({
  components: {SAccProjectJira}
})
export default class SAccProjectServices extends Vue {
  // Les props
  @Prop() private project!: ProjectDocument | null
  @Prop() public height!: number

  // Les propriétés
  public loading: boolean = false
  public Services: ServiceDocument[] = []

  // Les propriétés calculées
  private get account(): AccountDocument | null {
    return this.$store.state.accountData
  }

  public get PrjId() {
    return this.project ? this.project._id : undefined
  }

  // Les hooks
  public mounted() {
    this.loadServices()
  }

  // Les méthodes surveillées
  // Les méthodes d'instance
  private async loadServices() {
    this.loading = true
    if (this.account) {
      this.Services = await fetchServices(this.account._id)
    }
    this.loading = false
  }

  // Les méthodes statiques
}
